import React from 'react'
import clsx from 'clsx'
import { InputProps } from '@/components/atoms/Input/types'

export function Input({ type = 'text', placeholder, className, onChange, ...rest }: InputProps) {
  return (
    <input
      type={type}
      onChange={onChange}
      placeholder={placeholder}
      {...rest}
      // className={clsx(
      //   'focus:ring-primary-500 focus:border-primary-500 px-24 py-16 rounded border border-solid border-grey-100 text-text-dark-600 focus-within:outline-1 focus-within:outline-primary-500 focus-within:ring-2 focus-within:ring-primary-500 focus:border-transparent',
      //   className
      // )}
      className={clsx(
        'focus:shadow-input-border  px-24 py-16 rounded border border-solid border-grey-100 text-text-dark-600 focus-within:shadow-input-border focus:border-primary-500',
        className
      )}
    />
  )
}
